var _defs, _g, _g2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsEditProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-edit-1,.cls-edit-2{fill:none;}\n            .cls-edit-1{clip-rule:evenodd;}\n            .cls-edit-3{clip-path:url(#clip-path-edit-1);}\n            .cls-edit-4{clip-path:url(#clip-path-edit-2);}\n            .cls-edit-5{fill:currentColor;}\n            .cls-edit-6{clip-path:url(#clip-path-edit-3);}\n            .cls-edit-7{clip-path:url(#clip-path-edit-5);}\n            .cls-edit-8{clip-path:url(#clip-path-edit-6);}\n            .cls-edit-9{clip-path:url(#clip-path-edit-7);}\n            .cls-edit-10{clip-path:url(#clip-path-edit-8);}\n            .cls-edit-11{clip-path:url(#clip-path-edit-9);}\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-edit-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-edit-1",
    d: "M22.06,25.57h-21A1.09,1.09,0,0,1,0,24.48v-21A1.09,1.09,0,0,1,1.09,2.43H11.84a1.09,1.09,0,0,1,0,2.17H2.17V23.4H21V15.09a1.09,1.09,0,1,1,2.17,0v9.39a1.08,1.08,0,0,1-1.08,1.09"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-edit-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-edit-2",
    x: -1405,
    y: -301.57,
    width: 1528,
    height: 860
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-edit-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-edit-1",
    d: "M12.05,19.57H12l-3.87-.26a1.06,1.06,0,0,1-1-1l-.26-3.87a1,1,0,0,1,.31-.82L18.05,2.74a1.07,1.07,0,0,1,1.51,0l4.13,4.13a1.06,1.06,0,0,1,.31.75,1,1,0,0,1-.31.75L12.8,19.26A1.06,1.06,0,0,1,12.05,19.57ZM9.18,17.25l2.46.16,9.79-9.79L18.81,5,9,14.79Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-edit-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-edit-1",
    d: "M158.21,3.36a4.74,4.74,0,0,0-6.36,2.39,5.69,5.69,0,0,0,0,3.82,4.77,4.77,0,0,0,5.91,2.55,5.28,5.28,0,0,0,2.6-2.33,5.47,5.47,0,0,0,.26-3.72A5.51,5.51,0,0,0,158.21,3.36Zm-2.93-2.1a6.33,6.33,0,0,1,6.33,2.93,6.52,6.52,0,0,1-1.54,8.6A5.34,5.34,0,0,1,156.16,14a4.12,4.12,0,0,1-2.68-.54,6.45,6.45,0,0,1,1.8-12.2ZM167.69,10,169,11.27l-2,2,2,1.93-.56.58a2.15,2.15,0,0,1-.74.57,4.94,4.94,0,0,1-1.06-.9l-.9-.91-1,.92-.94.94-.63-.5c-.35-.29-.62-.57-.62-.67a4.82,4.82,0,0,1,.91-1.07l.92-.89-.92-.92a5.77,5.77,0,0,1-.91-1.06,2.68,2.68,0,0,1,.56-.71l.57-.58,2,2Zm-19,2.4h0c0,.06.28.39.49.7l.38.57-.79.76c-1.72,1.66-2,2.68-2,7,0,2.67,0,3.18.23,3.38s1,.22,6.76.23h3.6c5.94,0,7.95-.05,8.07-.17a10.13,10.13,0,0,0,.18-3V19h1.78v3.26c0,3.12-.15,3.54-1.14,4.16l-.57.36-9,0H153c-3.68,0-5.62-.05-6.05-.13a2.07,2.07,0,0,1-1.3-.74c-.52-.57-.67-.95-.68-2.82v-.42c0-.53,0-1.15,0-1.9a15.26,15.26,0,0,1,.33-4l0-.18a8.49,8.49,0,0,1,2.33-3.51c.48-.43.91-.74,1-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-edit-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-edit-1",
    points: "-144.75 11.59 -144.71 12.8 -133.69 12.8 -133.65 11.59 -133.6 10.4 -144.8 10.4 -144.75 11.59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-edit-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-edit-1",
    points: "-144.75 14.79 -144.71 16 -133.69 16 -133.65 14.79 -133.6 13.6 -144.8 13.6 -144.75 14.79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-edit-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-edit-1",
    d: "M-129.87,18.5a3.06,3.06,0,0,1,2,1.94,2.93,2.93,0,0,1-4,3.53,2.73,2.73,0,0,1-1.7-2.71,2.79,2.79,0,0,1,1.86-2.7A2.7,2.7,0,0,1-129.87,18.5Zm-2-2.39a5.35,5.35,0,0,0-3.46,7.71,5.16,5.16,0,0,0,2.48,2.33,6,6,0,0,0,4.28,0l.78-.35,2.2,2.17.82-.8.81-.8-1.12-1.13-1.13-1.13.34-.64a6.74,6.74,0,0,0,.3-3.61,5.81,5.81,0,0,0-1.86-2.76A5.71,5.71,0,0,0-131.91,16.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-edit-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-edit-1",
    d: "M73.82,7a4.83,4.83,0,0,0,0,3.25,4.05,4.05,0,0,0,5,2.16,4.46,4.46,0,0,0,2.21-2,4.67,4.67,0,0,0,.22-3.15A4.73,4.73,0,0,0,79.21,5,4,4,0,0,0,73.82,7ZM82.1,5.67A5.53,5.53,0,0,1,80.8,13a4.57,4.57,0,0,1-3.33,1,3.49,3.49,0,0,1-2.27-.46,5.45,5.45,0,0,1-2.55-7.38,5.56,5.56,0,0,1,4.07-3A5.38,5.38,0,0,1,82.1,5.67Zm8.23,4.46a.92.92,0,0,1,.88,0A1.16,1.16,0,0,1,92,11.25v.06c0,.53,0,.46-3.54,4.23-3.35,3.53-3.56,3.78-4,3.79h-.25c-.58,0-.73-.14-2-1.77s-1.4-1.78-1.4-2.11a1.35,1.35,0,0,1,.8-1.16c.69-.3,1-.14,2,1,.47.54.85,1,.86,1,.16-.22,1.48-1.6,2.84-3l.37-.38,1.07-1.08.33-.33C89.71,10.7,90.26,10.16,90.33,10.13Zm-19.2,2.51h0l.35.5.06.09.33.49-.67.64c-1.46,1.41-1.71,2.28-1.71,5.94,0,2.26,0,2.7.2,2.86l0,0,0,0c.27.12,1.28.15,5.66.15H78.5c5,0,6.75,0,6.85-.15a7.23,7.23,0,0,0,.15-2.35v-.95H87V21c0,2.57-.12,3-.9,3.49l-.07.05-.48.3-7.61,0H74.81c-3.12,0-4.77,0-5.13-.11a1.81,1.81,0,0,1-1.1-.63c-.44-.49-.57-.81-.58-2.4v-.36c0-.44,0-1,0-1.6a11.57,11.57,0,0,1,.33-3.57,7.17,7.17,0,0,1,2-3,3.17,3.17,0,0,1,.77-.58Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-edit-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-edit-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-edit-5",
    x: -1,
    y: 1.43,
    width: 25.14,
    height: 25.14
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-edit-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-edit-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-edit-5",
    x: 5.84,
    y: 1.43,
    width: 19.16,
    height: 19.14
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-edit-2",
    x: -640,
    y: -79.5,
    width: 1528,
    height: 860
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEditProfile);
export default __webpack_public_path__ + "static/media/icons_edit_profile.e792a7d6.svg";
export { ForwardRef as ReactComponent };